import React from 'react';
import { useNavigate } from 'react-router-dom';
import './row_alert.css';

// Generic bottom-right toast stack. Rendered once by RowAlertProvider; each toast already
// carries its own title/detail so toasts from different sources can share one stack.
// Clicking a toast (outside the close button) navigates to its source page, if any.
const RowAlertToastList = ({ toasts, removeToast }) => {
  const navigate = useNavigate();

  if (toasts.length === 0) return null;

  return (
    <div className="row-alert-container">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`row-alert-toast ${toast.linkTo ? 'row-alert-toast-clickable' : ''}`}
          onClick={() => toast.linkTo && navigate(toast.linkTo)}
          role={toast.linkTo ? 'button' : undefined}
          tabIndex={toast.linkTo ? 0 : undefined}
        >
          <div className="row-alert-toast-content">
            <span className="row-alert-toast-title">{toast.title}</span>
            <span className="row-alert-toast-detail">{toast.detail}</span>
          </div>
          <button
            className="row-alert-toast-close"
            onClick={(e) => {
              e.stopPropagation();
              removeToast(toast.id);
            }}
            aria-label="Dismiss"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
};

export default RowAlertToastList;
